import { render, staticRenderFns } from "./OrderUpdateProduct.vue?vue&type=template&id=21560488"
import script from "./OrderUpdateProduct.vue?vue&type=script&lang=js"
export * from "./OrderUpdateProduct.vue?vue&type=script&lang=js"
import style0 from "./OrderUpdateProduct.vue?vue&type=style&index=0&id=21560488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports